import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";

import SettingApi from "api/settingApi";
import BreadCrumb from "components/Common/BreadCrumb";
import DragMenu from "components/Common/DragMenu";
import DropdownAsyncCountries from "components/Common/DropdownAsyncCountries";
import Keywords from "components/Common/Keywords";
import ModalConfirm from "components/Common/ModalConfirm";
import * as Yup from "yup";
import IconBar from "../../../assets/images/icons/ic_bar.svg";
import IconBarWhite from "../../../assets/images/icons/ic_bar_white.svg";
import IconChat from "../../../assets/images/icons/ic_chat.svg";
import IconChatWhite from "../../../assets/images/icons/ic_chat_white.svg";
import IconNews from "../../../assets/images/icons/ic_news.svg";
import IconNewsWhite from "../../../assets/images/icons/ic_news_white.svg";
import IconProfile from "../../../assets/images/icons/ic_profile.svg";
import IconProfileWhite from "../../../assets/images/icons/ic_profile_white.svg";
import IconShop from "../../../assets/images/icons/ic_shop.svg";
import IconShopWhite from "../../../assets/images/icons/ic_shop_white.svg";
import IconWink from "../../../assets/images/icons/ic_wink.svg";
import IconWinkWhite from "../../../assets/images/icons/ic_wink_white.svg";

registerLocale("en", en);
registerLocale("ko", ko);

const BOTTOM_MENU_USER_ANDROID = [
  {
    id: "bar",
    text: "Bar List",
    icon: IconBar,
    iconEnable: IconBarWhite,
    checked: true,
  },
  {
    id: "wink",
    text: "Wink",
    icon: IconWink,
    iconEnable: IconWinkWhite,
    checked: true,
  },
  {
    id: "news",
    text: "News",
    icon: IconNews,
    iconEnable: IconNewsWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
];

const BOTTOM_MENU_USER_IOS = [
  {
    id: "bar",
    text: "Bar List",
    icon: IconBar,
    iconEnable: IconBarWhite,
    checked: true,
  },
  {
    id: "wink",
    text: "Wink",
    icon: IconWink,
    iconEnable: IconWinkWhite,
    checked: true,
  },
  {
    id: "news",
    text: "News",
    icon: IconNews,
    iconEnable: IconNewsWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
];

const BOTTOM_MENU_MANAGER_ANDROID = [
  {
    id: "bar_management",
    text: "Bar Info",
    icon: IconShop,
    iconEnable: IconShopWhite,
    checked: true,
  },
  {
    id: "bar",
    text: "Bar List",
    icon: IconBar,
    iconEnable: IconBarWhite,
    checked: true,
  },
  {
    id: "wink",
    text: "Wink",
    icon: IconWink,
    iconEnable: IconWinkWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
  {
    id: "news",
    text: "News",
    icon: IconNews,
    iconEnable: IconNewsWhite,
    checked: true,
  },
];

const BOTTOM_MENU_MANAGER_IOS = [
  {
    id: "bar_management",
    text: "Bar Info",
    icon: IconShop,
    iconEnable: IconShopWhite,
    checked: true,
  },
  {
    id: "bar",
    text: "Bar List",
    icon: IconBar,
    iconEnable: IconBarWhite,
    checked: true,
  },
  {
    id: "wink",
    text: "Wink",
    icon: IconWink,
    iconEnable: IconWinkWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
  {
    id: "news",
    text: "News",
    icon: IconNews,
    iconEnable: IconNewsWhite,
    checked: true,
  },
];

const BOTTOM_MENU_BARTENDER_ANDROID = [
  {
    id: "bar",
    text: "Bar List",
    icon: IconBar,
    iconEnable: IconBarWhite,
    checked: true,
  },
  {
    id: "wink",
    text: "Wink",
    icon: IconWink,
    iconEnable: IconWinkWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
  {
    id: "news",
    text: "News",
    icon: IconNews,
    iconEnable: IconNewsWhite,
    checked: true,
  },
];

const BOTTOM_MENU_BARTENDER_IOS = [
  {
    id: "bar",
    text: "Bar List",
    icon: IconBar,
    iconEnable: IconBarWhite,
    checked: true,
  },
  {
    id: "wink",
    text: "Wink",
    icon: IconWink,
    iconEnable: IconWinkWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
  {
    id: "news",
    text: "News",
    icon: IconNews,
    iconEnable: IconNewsWhite,
    checked: true,
  },
];

const AppSetting = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedCountries, setSelectedCountries] = useState<any>(null);
  const [typeTab, setTypeTab] = useState<string>("1");
  const [confirm, setConfirm] = useState<any>();
  const [errors, setErrors] = useState<any>({});

  const handleSubmit = async (values: any) => {
    setIsLoading(true);

    const formatedData = {
      app_version_manager: {
        max_ios_app_version: values?.max_version_ios,
        min_ios_app_version: values?.min_version_ios,
        max_and_app_version: values?.max_version_android,
        min_and_app_version: values?.min_version_android,
        reload_menu_time: values?.reload_menu_time,
        background_data_collection_time:
          values?.background_data_collection_time,
        news_ips: values?.whitelist_ip_news,
        news_country_codes: values?.whitelist_country_news?.map(
          (item: any) => item?.value || item
        ),
        emails_bypass_account_creation: values?.exception_email_list,
        device_uuids_bypass_account_creation: values?.exception_uuid_list,
        ios_bottom_menu_manager: values?.bottom_menu_manager_ios,
        android_bottom_menu_manager: values?.bottom_menu_manager_android,
        ios_bottom_menu_bartender: values?.bottom_menu_bartender_ios,
        android_bottom_menu_bartender: values?.bottom_menu_bartender_android,
      },
      app_version_user: {
        max_ios_app_version: values?.manager_max_version_ios,
        min_ios_app_version: values?.manager_min_version_ios,
        max_and_app_version: values?.manager_max_version_android,
        min_and_app_version: values?.manager_min_version_android,
        reload_menu_time: values?.reload_menu_time,
        background_data_collection_time:
          values?.background_data_collection_time,
        news_ips: values?.whitelist_ip_news,
        news_country_codes: values?.whitelist_country_news?.map(
          (item: any) => item?.value || item
        ),
        emails_bypass_account_creation: values?.exception_email_list,
        device_uuids_bypass_account_creation: values?.exception_uuid_list,
        ios_bottom_menu_user: values?.bottom_menu_user_ios,
        android_bottom_menu_user: values?.bottom_menu_user_android,
      },
    };

    try {
      const response: any = await SettingApi.putSetting(formatedData);
      if (response?.code === 200) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading((_prev) => false);
        if (response.success == false) {
          toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
        }
      }
    } catch (error: any) {
      toast(`${error}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    // exception_email_list: Yup.array()
    //   .of(Yup.string().email(t("invalid_email")).required(t("required_email")))
    //   .min(1, t("min_email")),
    whitelist_ip_news: Yup.array().of(
      Yup.string().matches(
        /^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])){3}$/,
        t("invalid_ip")
      )
      // .required(t("required_ip"))
    ),
    // .min(1, t("min_ip"))
    min_version_ios: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    min_version_android: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    max_version_ios: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    max_version_android: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    manager_min_version_ios: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    manager_min_version_android: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    manager_max_version_ios: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    manager_max_version_android: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    exception_uuid_list: Yup.array().of(
      Yup.string().matches(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
        t("invalidUUID")
      )
    ),
  });

  const formik = useFormik({
    initialValues: {
      min_version_ios: "",
      min_version_android: "",
      max_version_ios: "",
      max_version_android: "",
      bottom_menu_user_android: BOTTOM_MENU_USER_ANDROID,
      bottom_menu_user_ios: BOTTOM_MENU_USER_IOS,
      bottom_menu_manager_android: BOTTOM_MENU_MANAGER_ANDROID,
      bottom_menu_manager_ios: BOTTOM_MENU_MANAGER_IOS,
      bottom_menu_bartender_android: BOTTOM_MENU_BARTENDER_ANDROID,
      bottom_menu_bartender_ios: BOTTOM_MENU_BARTENDER_IOS,
      reload_menu_time: "",
      whitelist_ip_news: [],
      whitelist_country_news: null,
      background_data_collection_time: "",
      exception_email_list: [],
      exception_uuid_list: [],
      manager_min_version_ios: "",
      manager_min_version_android: "",
      manager_max_version_ios: "",
      manager_max_version_android: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleChangeIPNews = (keywords: any) => {
    if (keywords?.length > formik?.values?.whitelist_ip_news?.length) {
      const temp = keywords?.find((item: any) => {
        return !/^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])){3}$/.test(
          item
        );
      });

      if (temp) {
        setErrors({
          ...errors,
          whitelist_ip_news: t("invalid_ip"),
        });
      } else {
        setErrors({
          ...errors,
          whitelist_ip_news: "",
        });
        formik.setFieldValue("whitelist_ip_news", keywords);
      }
    } else {
      setConfirm({
        open: true,
        onConfirm: () => {
          setConfirm({ open: false });
          formik.setFieldValue("whitelist_ip_news", keywords);
        },
      });
    }
  };

  const handleChangeEmailList = (keywords: any) => {
    if (keywords?.length > formik?.values?.exception_email_list?.length) {
      const temp = keywords?.find((item: any) => {
        return !Yup.string().email(t("invalid_email")).isValidSync(item);
      });

      if (temp) {
        setErrors({
          ...errors,
          exception_email_list: t("invalid_email"),
        });
      } else {
        setErrors({
          ...errors,
          exception_email_list: "",
        });
        formik.setFieldValue("exception_email_list", keywords);
      }
    } else {
      setConfirm({
        open: true,
        onConfirm: () => {
          setConfirm({ open: false });
          formik.setFieldValue("exception_email_list", keywords);
        },
      });
    }
  };

  const handleChangeUUIDList = (keywords: any) => {
    if (keywords?.length > formik?.values?.exception_uuid_list?.length) {
      const temp = keywords?.find((item: any) => {
        return !Yup.string()
          .matches(
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
            t("invalidUUID")
          )
          .isValidSync(item);
      });
      if (temp) {
        setErrors({
          ...errors,
          exception_uuid_list: t("invalidUUID"),
        });
      } else {
        setErrors({
          ...errors,
          exception_uuid_list: "",
        });
        formik.setFieldValue("exception_uuid_list", keywords);
      }
    } else {
      setConfirm({
        open: true,
        onConfirm: () => {
          setConfirm({ open: false });
          formik.setFieldValue("exception_uuid_list", keywords);
        },
      });
    }
  };

  useEffect(() => {
    document.title = `${t("App Setting")} - ${t("Setting Manager")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const handleData = async () => {
    setIsLoading((_prev) => true);
    try {
      const response: any = await SettingApi.getSetting();
      formik?.setValues({
        min_version_ios:
          response?.data?.app_version_user?.min_ios_app_version || "",
        min_version_android:
          response?.data?.app_version_user?.min_and_app_version || "",
        max_version_ios:
          response?.data?.app_version_user?.max_ios_app_version || "",
        max_version_android:
          response?.data?.app_version_user?.max_and_app_version || "",
        bottom_menu_user_android:
          response?.data?.app_version_user?.android_bottom_menu_user ||
          BOTTOM_MENU_USER_ANDROID,
        bottom_menu_user_ios:
          response?.data?.app_version_user?.ios_bottom_menu_user ||
          BOTTOM_MENU_USER_IOS,
        bottom_menu_manager_android:
          response?.data?.app_version_manager?.android_bottom_menu_manager ||
          BOTTOM_MENU_MANAGER_ANDROID,
        bottom_menu_manager_ios:
          response?.data?.app_version_manager?.ios_bottom_menu_manager ||
          BOTTOM_MENU_MANAGER_IOS,
        bottom_menu_bartender_android:
          response?.data?.app_version_manager?.android_bottom_menu_bartender ||
          BOTTOM_MENU_BARTENDER_ANDROID,
        bottom_menu_bartender_ios:
          response?.data?.app_version_manager?.ios_bottom_menu_bartender ||
          BOTTOM_MENU_BARTENDER_IOS,
        reload_menu_time: response?.data?.common?.reload_menu_time || "",
        whitelist_ip_news: response?.data?.common?.news_ips || [],
        whitelist_country_news:
          response?.data?.common?.news_country_codes || null,
        background_data_collection_time:
          response?.data?.common?.background_data_collection_time || "",
        exception_email_list:
          response?.data?.common?.emails_bypass_account_creation || [],
        exception_uuid_list:
          response?.data?.common?.device_uuids_bypass_account_creation || [],
        manager_min_version_ios:
          response?.data?.app_version_manager?.min_ios_app_version || "",
        manager_min_version_android:
          response?.data?.app_version_manager?.min_and_app_version || "",
        manager_max_version_ios:
          response?.data?.app_version_manager?.max_ios_app_version || "",
        manager_max_version_android:
          response?.data?.app_version_manager?.max_and_app_version || "",
      });
      setSelectedCountries(response?.data?.common?.news_country_codes || null);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading((_prev) => false);
    }
  };

  useEffect(() => {
    handleData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content  app-setting">
        <Container fluid>
          <BreadCrumb title={t("App Setting")} pageTitle={t("Home")} />

          <form onSubmit={formik.handleSubmit}>
            <Row>
              <Col lg={6} xl={5} xxl={4}>
                <div
                  className="position-relative mb-3 mt-1 mt-md-0"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                    padding: "10px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("General")}
                  </span>
                  <Row>
                    <Col lg={12} className="mt-2">
                      <div className="mb-3" style={{ maxWidth: "460px" }}>
                        <Label
                          htmlFor="reload_menu_time"
                          className="form-label"
                        >
                          {t("menu_auto_refresh_interval")}{" "}
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <Input
                          name="reload_menu_time"
                          type="number"
                          className="form-control"
                          id="titleInput"
                          placeholder={t("enter_menu_auto_refresh_interval")}
                          value={formik?.values?.reload_menu_time}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "reload_menu_time",
                              event?.target?.value
                            );
                          }}
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3" style={{ maxWidth: "460px" }}>
                        <Label
                          htmlFor="background_data_collection_time"
                          className="form-label"
                        >
                          {t("lat_long_interval")}{" "}
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <Input
                          name="background_data_collection_time"
                          type="text"
                          className="form-control"
                          id="titleInput"
                          placeholder={t("enter_lat_long_interval")}
                          value={
                            formik?.values?.background_data_collection_time
                          }
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "background_data_collection_time",
                              event?.target?.value
                            );
                          }}
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3" style={{ maxWidth: "460px" }}>
                        <Label
                          htmlFor="whitelist_country_news"
                          className="form-label"
                        >
                          {t("allowed_countries_news")}{" "}
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <DropdownAsyncCountries
                          name="whitelist_country_news"
                          onChangeSelect={(event: any) => {
                            formik.setFieldValue(
                              "whitelist_country_news",
                              event
                            );
                            setSelectedCountries(event);
                          }}
                          isMulti={true}
                          placeholder={`${t("select_countries")}...`}
                          isShowIconCheck={false}
                          isAllOption={false}
                          listCheckedUsers={selectedCountries}
                          key={`list-countries`}
                        />

                        {formik?.touched?.whitelist_country_news &&
                        formik?.errors?.whitelist_country_news ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.whitelist_country_news}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3" style={{ maxWidth: "460px" }}>
                        <Label
                          htmlFor="whitelist_ip_news"
                          className="form-label"
                        >
                          {t("allowed_ips_news")}{" "}
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <Keywords
                          name="whitelist_ip_news"
                          placeholder={`${t("enter_ip")}...`}
                          suggestions={[]}
                          initialValue={formik?.values?.whitelist_ip_news?.map(
                            (item: any) => ({
                              id: item?.toLowerCase(),
                              text: item,
                            })
                          )}
                          errDuplicate={t("ip_exists")}
                          textColor={"#FFF"}
                          bgColor={"#FFF"}
                          isChangeSelectedColor={true}
                          onChangeTag={(event) => {
                            const keywords = event?.map((item) => item.text);
                            handleChangeIPNews(keywords);
                          }}
                        />
                        {errors?.whitelist_ip_news ? (
                          <div className="text-danger mt-2">
                            {errors?.whitelist_ip_news}
                          </div>
                        ) : formik?.touched?.whitelist_ip_news &&
                          formik?.errors?.whitelist_ip_news ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.whitelist_ip_news}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    {/* <Col lg={12}>
                      <div className="mb-3" style={{ maxWidth: "460px" }}>
                        <Label
                          htmlFor="exception_email_list"
                          className="form-label"
                        >
                          {t("bypass_email_list")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Keywords
                          name="exception_email_list"
                          placeholder={`${t("enter_email")}...`}
                          suggestions={[]}
                          initialValue={formik?.values?.exception_email_list?.map(
                            (item: any) => ({
                              id: item?.toLowerCase(),
                              text: item,
                            })
                          )}
                          textColor={"#333333"}
                          bgColor={"#f5f5f5"}
                          isChangeSelectedColor={true}
                          onChangeTag={(event) => {
                            const keywords = event?.map((item) => item.text);
                            handleChangeEmailList(keywords);
                          }}
                        />
                        {errors?.exception_email_list ? (
                          <div className="text-danger mt-2">
                            {errors?.exception_email_list}
                          </div>
                        ) : formik?.touched?.exception_email_list &&
                          formik?.errors?.exception_email_list ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.exception_email_list}
                          </div>
                        ) : null}
                      </div>
                    </Col> */}

                    <Col lg={12}>
                      <div className="mb-3" style={{ maxWidth: "460px" }}>
                        <Label
                          htmlFor="exception_uuid_list"
                          className="form-label"
                        >
                          {t("bypass_uuid_list")}{" "}
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <Keywords
                          name="exception_uuid_list"
                          placeholder={`${t("enter_uuid")}...`}
                          suggestions={[]}
                          initialValue={formik?.values?.exception_uuid_list?.map(
                            (item: any) => ({
                              id: item?.toLowerCase(),
                              text: item,
                            })
                          )}
                          textColor={"#333333"}
                          bgColor={"#f5f5f5"}
                          isChangeSelectedColor={true}
                          onChangeTag={(event) => {
                            const keywords = event?.map((item) => item.text);
                            handleChangeUUIDList(keywords);
                          }}
                        />
                        {errors?.exception_uuid_list ? (
                          <div className="text-danger mt-2">
                            {errors?.exception_uuid_list}
                          </div>
                        ) : formik?.touched?.exception_uuid_list &&
                          formik?.errors?.exception_uuid_list ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.exception_uuid_list}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={6} xl={7} xxl={8}>
                <div
                  style={{
                    background: "#f3f6f9",
                    borderTopLeftRadius: "0.6rem",
                    borderTopRightRadius: "0.6rem",
                    position: "sticky",
                    top: "-20px",
                    zIndex: 99,
                  }}
                >
                  <div
                    className="d-block"
                    style={{
                      background: "#f3f6f9",
                      borderRadius: "0.6rem",
                      width: "fit-content",
                    }}
                  >
                    <Nav tabs className="nav nav-tabs nav-justified">
                      <li className="list-inline-item">
                        <NavItem>
                          <NavLink
                            style={{
                              cursor: "pointer",
                              background: `${
                                typeTab === "1" ? "#009ef7" : "unset"
                              }`,
                              color: `${typeTab === "1" ? "white" : "#009ef7"}`,
                              borderWidth: 0,
                            }}
                            className={
                              typeTab === "1"
                                ? "bar-detail active"
                                : "bar-detail"
                            }
                            onClick={() => setTypeTab("1")}
                          >
                            {t("User")}
                          </NavLink>
                        </NavItem>
                      </li>
                      <li className="list-inline-item">
                        <NavItem>
                          <NavLink
                            style={{
                              cursor: "pointer",
                              background: `${
                                typeTab === "2" ? "#009ef7" : "unset"
                              }`,
                              color: `${typeTab === "2" ? "white" : "#009ef7"}`,
                              borderWidth: 0,
                            }}
                            className={
                              typeTab === "2"
                                ? "bar-detail active"
                                : "bar-detail"
                            }
                            onClick={() => setTypeTab("2")}
                          >
                            {t("Manager")}
                          </NavLink>
                        </NavItem>
                      </li>
                    </Nav>
                  </div>
                </div>

                <TabContent
                  activeTab={typeTab}
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderTop: "1px solid transparent",
                    padding: "0px 10px",
                    borderBottomLeftRadius: "4px",
                    borderBottomRightRadius: "4px",
                  }}
                >
                  <TabPane tabId={"1"} className="position-relative">
                    <Row className="mt-3">
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="min_version_ios"
                            className="form-label"
                          >
                            {t("min_ios_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="min_version_ios"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_min_ios_version")}
                            value={formik?.values?.min_version_ios}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "min_version_ios",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.min_version_ios &&
                          formik?.errors?.min_version_ios ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.min_version_ios}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="max_version_ios"
                            className="form-label"
                          >
                            {t("latest_ios_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="max_version_ios"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_latest_ios_version")}
                            value={formik?.values?.max_version_ios}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "max_version_ios",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.max_version_ios &&
                          formik?.errors?.max_version_ios ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.max_version_ios}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="min_version_android"
                            className="form-label"
                          >
                            {t("min_android_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="min_version_android"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_min_android_version")}
                            value={formik?.values?.min_version_android}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "min_version_android",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.min_version_android &&
                          formik?.errors?.min_version_android ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.min_version_android}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="max_version_android"
                            className="form-label"
                          >
                            {t("latest_android_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="max_version_android"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_latest_android_version")}
                            value={formik?.values?.max_version_android}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "max_version_android",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.max_version_android &&
                          formik?.errors?.max_version_android ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.max_version_android}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="bottom_menu_user_android"
                            className="form-label"
                          >
                            {t("user_bottom_menu_android")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DragMenu
                            menuList={formik.values?.bottom_menu_user_android}
                            name="bottom_menu_user_android"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                "bottom_menu_user_android",
                                e
                              );
                            }}
                          />
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="bottom_menu_user_ios"
                            className="form-label"
                          >
                            {t("user_bottom_menu_ios")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DragMenu
                            menuList={formik.values?.bottom_menu_user_ios}
                            name="bottom_menu_user_ios"
                            onChange={(e: any) => {
                              formik.setFieldValue("bottom_menu_user_ios", e);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={"2"} className="position-relative">
                    <Row className="mt-3">
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="manager_min_version_ios"
                            className="form-label"
                          >
                            {t("min_ios_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="manager_min_version_ios"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_min_ios_version")}
                            value={formik?.values?.manager_min_version_ios}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "manager_min_version_ios",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.manager_min_version_ios &&
                          formik?.errors?.manager_min_version_ios ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.manager_min_version_ios}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="manager_max_version_ios"
                            className="form-label"
                          >
                            {t("latest_ios_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="manager_max_version_ios"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_latest_ios_version")}
                            value={formik?.values?.manager_max_version_ios}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "manager_max_version_ios",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.manager_max_version_ios &&
                          formik?.errors?.manager_max_version_ios ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.manager_max_version_ios}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="manager_min_version_android"
                            className="form-label"
                          >
                            {t("min_android_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="manager_min_version_android"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_min_android_version")}
                            value={formik?.values?.manager_min_version_android}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "manager_min_version_android",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.manager_min_version_android &&
                          formik?.errors?.manager_min_version_android ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.manager_min_version_android}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="manager_max_version_android"
                            className="form-label"
                          >
                            {t("latest_android_version")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="manager_max_version_android"
                            type="text"
                            className="form-control"
                            id="titleInput"
                            placeholder={t("enter_latest_android_version")}
                            value={formik?.values?.manager_max_version_android}
                            onChange={(event: any) => {
                              formik.setFieldValue(
                                "manager_max_version_android",
                                event?.target?.value
                              );
                            }}
                          />
                          {formik?.touched?.manager_max_version_android &&
                          formik?.errors?.manager_max_version_android ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.manager_max_version_android}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="bottom_menu_manager_android"
                            className="form-label"
                          >
                            {t("manager_bottom_menu_android")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DragMenu
                            menuList={
                              formik.values?.bottom_menu_manager_android
                            }
                            name="bottom_menu_manager_android"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                "bottom_menu_manager_android",
                                e
                              );
                            }}
                          />
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="bottom_menu_manager_ios"
                            className="form-label"
                          >
                            {t("manager_bottom_menu_ios")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DragMenu
                            menuList={formik.values?.bottom_menu_manager_ios}
                            name="bottom_menu_manager_ios"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                "bottom_menu_manager_ios",
                                e
                              );
                            }}
                          />
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="bottom_menu_bartender_android"
                            className="form-label"
                          >
                            {t("bartender_bottom_menu_android")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DragMenu
                            menuList={
                              formik.values?.bottom_menu_bartender_android
                            }
                            name="bottom_menu_bartender_android"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                "bottom_menu_bartender_android",
                                e
                              );
                            }}
                          />
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="bottom_menu_bartender_ios"
                            className="form-label"
                          >
                            {t("bartender_bottom_menu_ios")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DragMenu
                            menuList={formik.values?.bottom_menu_bartender_ios}
                            name="bottom_menu_bartender_ios"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                "bottom_menu_bartender_ios",
                                e
                              );
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>

              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end my-4">
                  <button
                    className="btn btn-primary fs-14"
                    color="success"
                    type="submit"
                    disabled={isLoading}
                    style={{ width: "140px" }}
                  >
                    {isLoading ? (
                      <Spinner size="sm" className="me-2"></Spinner>
                    ) : (
                      <>{t("Update")}</>
                    )}
                  </button>
                </div>
              </Col>
            </Row>
          </form>
          <ToastContainer closeButton={false} limit={1} />
        </Container>
      </div>
      {confirm?.open && (
        <ModalConfirm
          header={t("Delete Item")}
          isOpen={confirm?.open}
          onClose={() => setConfirm({ ...confirm, open: false })}
          onConfirm={() => confirm?.onConfirm()}
        />
      )}
    </React.Fragment>
  );
};

export default AppSetting;
